/*!
 * devextreme-vue
 * Version: 24.1.7
 * Build date: Wed Oct 30 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-vue
 */

export function createComponent() {
    throw new Error('Since v23.2, devextreme-vue no longer supports Vue 2. See: https://supportcenter.devexpress.com/ticket/details/T1186771');
}
export function createConfigurationComponent() {
}
export function createExtensionComponent() {
}
